<script>
	export let name = "";

	export let title = "Darkfrydle";
	export let titleColor = "#A806A0";

	export let hotcydleMode = false;

	export let responseText = "";

	export let devMode = false;

	const dles = ["Wordle", "#Heardle", "Framed", "Daily Quordle", "#waffle", "#canuffle", "Connections", "🍋 Squeezy", "I solved the ", "Strands #"]

	if (window.location.href.indexOf("hotcydle") > -1) {
		title = "Hotcydle"
		titleColor = "#ff6723"
		hotcydleMode = true;
    }else if(window.location.href.indexOf("darkfrydle") > -1){
		title = "Darkfrydle"
		titleColor = "#A806A0"
	}else{
		devMode = true;
	}

	function handleClick(){
		console.log(dles)
		console.log(name)
		if(!dles.some(x => name.startsWith(x))){
			responseText = "That's not a Wordle! :("
		}else{
			if(hotcydleMode){
				if(name.includes("New York Times Mini Crossword")){
					const toCopy = name + "\nI am also HotCyder. I have a YouTube channel that you can visit at https://youtube.com/@hotcyder."
					navigator.clipboard.writeText(toCopy);
					responseText = "Copied!"
					return;
				}

				const connections = name.includes("Connections")

				var toCopy = name
				.replaceAll("🔵", "🐋")
				.replaceAll("🟡", "🦒")
				.replaceAll("🟩", "🐊")
				.replaceAll("🟧", "🐊")
				.replaceAll("🟨", "🦒")
				.replaceAll("🟦", connections ? "🐋" : "🦒")
				.replaceAll("🟪", "🍇")
				.replaceAll("🟥", "🦀")
				.replaceAll("Strands", "Hotstrands")
				.replaceAll("Wordle", "Hotcydle")
				.replaceAll("Heardle", "Hearcydle")
				.replaceAll("Quordle", "Hotquordle")
				.replace("waffle", "Hotwaffle")
				.replace("canuffle", "Cancydle")
				.replace("Squeezy", "HotSqueezy")
				.replaceAll("Connections", "Hotconnections")
				.replaceAll("Framed", "Hotframed");
				if(name.toLowerCase().includes("heardle")){
					toCopy = toCopy
					.replaceAll("⬛", "🦛")
					.replaceAll("⬜", "☁️")
				}else{
					toCopy = toCopy
					.replaceAll("⬛", "🦛")
					.replaceAll("⬜", "🦛")
				}
				navigator.clipboard.writeText(toCopy);
				responseText = "Copied!"
			}else{
				var toCopy = name
				.replaceAll("⬛", ":maddrk:")
				.replaceAll("⬜", ":maddrk:")
				.replaceAll("🟩", ":exciteddrk:")
				.replaceAll("🟧", ":exciteddrk:")
				.replaceAll("🟨", ":drooldrk:")
				.replaceAll("🟦", ":drooldrk:")
				.replaceAll("Wordle", "Darkfrydle");
				navigator.clipboard.writeText(toCopy);
				responseText = "Copied!"
			}
		}
	}

	function toggleTitle(){
		if(title === "Darkfrydle"){
			title = "Hotcydle"
			titleColor = "#ff6723"
		}else{
			title = "Darkfrydle"
			titleColor = "#A806A0"
		}
	}
</script>

<main>
	<h1 style="color: {titleColor}">{title}</h1>
	<div>
		<textarea class="paste-area" bind:value={name}/><br/>
		<button style="margin-top: 40px" on:click={handleClick}>{title} my Wordle!</button><br/>
		<p>{responseText}</p>
	</div>
	<br/>
	<label for="hotcydle-mode">Hotcydle Mode</label>
	<input name="hotcydle-mode" type=checkbox on:change={toggleTitle} bind:checked={hotcydleMode}/>	


</main>

<style>
	main {
		text-align: center;
		padding: 1em;
		margin: 0 auto;
	}

	.paste-area{
		width: 80%;
		min-height: 300px;
	}

	h1 {
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}

</style>
